// MF SERVICIOS DE SEGUROS — interacciones
(function () {
  'use strict';

  /* Header: sombra al hacer scroll */
  var header = document.querySelector('.mf-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Revelado palabra por palabra del título del hero */
  var heroTitle = document.querySelector('.mf-hero__title');
  if (heroTitle && !heroTitle.dataset.processed) {
    heroTitle.dataset.processed = 'true';
    var html = heroTitle.innerHTML;
    var parts = html.split(/(<[^>]+>[^<]*<\/[^>]+>)/g);
    var wordIndex = 0;
    var result = '';

    parts.forEach(function (part) {
      if (part.indexOf('<') === 0) {
        var match = part.match(/<([^>]+)>([^<]*)<\/[^>]+>/);
        if (match) {
          var tag = match[1];
          var content = match[2];
          var words = content.split(/(\s+)/).filter(function (w) { return w.length > 0; });
          var inner = '';
          words.forEach(function (word) {
            if (word.trim()) {
              inner += '<span class="word" style="animation-delay:' + (0.15 + wordIndex * 0.07) + 's">' + word + '</span>';
              wordIndex++;
            } else {
              inner += word;
            }
          });
          result += '<' + tag + '>' + inner + '</' + tag.split(' ')[0].replace(/^\//, '') + '>';
        }
      } else {
        var plainWords = part.split(/(\s+)/).filter(function (w) { return w.length > 0; });
        plainWords.forEach(function (word) {
          if (word.trim()) {
            result += '<span class="word" style="animation-delay:' + (0.15 + wordIndex * 0.07) + 's">' + word + '</span>';
            wordIndex++;
          } else {
            result += word;
          }
        });
      }
    });
    heroTitle.innerHTML = result;
  }

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  /* Burbuja de WhatsApp */
  var whatsapp = document.querySelector('[data-whatsapp]');
  if (whatsapp) {
    var toggleBtn = whatsapp.querySelector('[data-whatsapp-toggle]');
    var badge = whatsapp.querySelector('[data-whatsapp-badge]');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        whatsapp.classList.toggle('is-open');
        if (badge) badge.classList.add('is-hidden');
      });
    }
    document.addEventListener('click', function (e) {
      if (whatsapp.classList.contains('is-open') && !whatsapp.contains(e.target)) {
        whatsapp.classList.remove('is-open');
      }
    });
  }

  /* Modales legales del footer */
  var overlay = document.getElementById('mf-modal-overlay');
  if (overlay) {
    var title = document.getElementById('mf-modal-title');
    var body = document.getElementById('mf-modal-body');
    var closeBtn = document.getElementById('mf-modal-close');

    var openModal = function (key) {
      var template = document.querySelector('[data-modal-content="' + key + '"]');
      if (!template) return;
      title.textContent = template.dataset.modalTitle || '';
      body.innerHTML = template.innerHTML;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    var closeModal = function () {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    document.querySelectorAll('[data-modal-trigger]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(link.getAttribute('data-modal-trigger'));
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }
})();
